import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { InsuranceVendor } from '@ld.consumer-portal/models';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export interface InsuranceProviderSelectionEvent {
  vendor: InsuranceVendor;
}

@Component({
  selector: 'ld-insurance-provider-selection-modal',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './insurance-provider-selection-modal.component.html',
  styleUrl: './insurance-provider-selection-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuranceProviderSelectionModalComponent {
  readonly availableVendors = input<InsuranceVendor[]>(['geico', 'mello']);

  readonly select = output<InsuranceProviderSelectionEvent>();

  readonly cancel = output<void>();

  protected readonly selectedProvider = signal<InsuranceVendor | null>(null);

  protected onProviderSelect(vendor: InsuranceVendor): void {
    this.selectedProvider.set(vendor);
  }

  protected onContinue(): void {
    const selected = this.selectedProvider();
    if (selected) {
      this.select.emit({ vendor: selected });
    }
  }

  protected onCancel(): void {
    this.cancel.emit();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.cancel.emit();
    }
  }

  protected isVendorAvailable(vendor: InsuranceVendor): boolean {
    return this.availableVendors().includes(vendor);
  }
}
